import { Table } from "antd";

import { ATTACHMENT } from "@/utils/enum";
import LazyImageRender from "../LazyImageRender";

interface Props {
  record: any;
}
const HeroContentDataTable = ({ record }: Props) => {
  const dataColumn = [
    {
      title: "Image Attachment",
      dataIndex: "image_attachment_id",
      key: "image_attachment_id",
      ellipsis: true,
      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <LazyImageRender id={text} attachmentType={ATTACHMENT.IMAGE} />;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "Subtitle",
      dataIndex: "subtitle",
      key: "subtitle",
      ellipsis: true,
      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "Expandable",
      dataIndex: "is_expandable",
      key: "is_expandable",
      ellipsis: true,

      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <div>{text ? "Yes" : "No"}</div>;
      },
    },
    {
      title: "CTA Redirection",
      dataIndex: "cta_redirection_type",
      key: "cta_redirection_type",
      ellipsis: true,
      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "CTA Text",
      dataIndex: "cta_text",
      key: "cta_text",
      ellipsis: true,
      width: "10%",
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
  ];
  return (
    <div className="padding-left">
      <Table
        columns={dataColumn}
        dataSource={record?.content?.items || []}
        pagination={false}
        scroll={{ y: 240 }}
      ></Table>
    </div>
  );
};
export default HeroContentDataTable;
